module.exports = __webpack_public_path__ + "img/code-download-btn.b4df8835.png";